import React, { ReactNode } from 'react';

import { Card, Grid } from 'antd';

type Props = { title: string, children: ReactNode }

export function GuestsLogsPageCard({ title, children }: Props) {
    const { lg: isDesktop } = Grid.useBreakpoint();

    const size = isDesktop ? 'default' : 'small';

    return (
        <Card
            title={title}
            size={size}
        >
            {children}
        </Card>
    );
}
